import C9200L_24P_4G from '../SvgInterfaces/C9200L_24P_4G';
import C9200L_48P_4G from '../SvgInterfaces/C9200L_48P_4G';
import InterfacesChunks from './InterfacesChunks';

export default function AdministratorSvgInterfaces({ interfacesChunks, interfaceModel, interfaceHover, tooltipPosition, isTooltipVisible }) {
    const model = interfaceModel.makeModel;

    return (
        <>
            {model === 'C9200L-24P-4G' ? (
                <C9200L_24P_4G
                    interfaceId={interfaceModel.id}
                    interfaceHover={interfaceHover}
                    tooltipPosition={tooltipPosition}
                    isTooltipVisible={isTooltipVisible}
                />
                // ) : model === 'C9200L-48P-4X' ? (
                //     <C9200L_48P_4G interfaceId={interfaceModel.id} interfaceHover={interfaceHover} tooltipPosition={tooltipPosition} isTooltipVisible={isTooltipVisible}/>
            ) : (
                <>
                    {interfacesChunks.map((data, index) => (
                        <div key={index}>
                            <InterfacesChunks
                                interfaceId={interfaceModel.id}
                                interfaceData={data}
                                interfaceHover={interfaceHover}
                                tooltipPosition={tooltipPosition}
                                isTooltipVisible={isTooltipVisible}
                            />
                        </div>
                    ))}
                </>
            )}
        </>
    )
}